/* eslint-disable-file */
import { Button, Checkbox, Modal } from '@getsynapse/design-system';
import ConfigureEventViewIcon from 'assets/icons/configure.svg';
import intl from 'react-intl-universal';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectViewSettingValues,
  createUpdateUserViewSetting,
  getViewSettingValues,
  selectUserViewSettingValues,
} from 'state/ViewSettings/viewSettingsSlice';
import { useEffect, useState } from 'react';
import {
  FM_CONFIGURATION_OPTION_KEY,
  FM_CONFIGURATION_OPTION_VALUES,
} from 'utils/constants/fmSettingsModal';
interface SettingsModalProps {
  showModal: boolean;
  onClose: () => void;
}
const SettingsModal: React.FC<SettingsModalProps> = ({
  showModal,
  onClose,
}) => {
  const dispatch = useDispatch();
  const fmConfigurationOptions = useSelector(
    selectViewSettingValues(FM_CONFIGURATION_OPTION_KEY)
  );

  const currentUserViewSetting = useSelector(
    selectUserViewSettingValues(FM_CONFIGURATION_OPTION_KEY)
  );

  // Local state for checkbox value - default to true
  const [isPublicHolidaysEnabled, setIsPublicHolidaysEnabled] = useState(true);
  // Store the original value when component mounts
  const [originalValue, setOriginalValue] = useState(true);

  useEffect(() => {
    dispatch(getViewSettingValues([FM_CONFIGURATION_OPTION_KEY]));
  }, [dispatch]);

  // Update local state when Redux state changes and store original value
  useEffect(() => {
    const isEnabled =
      currentUserViewSetting?.value ===
      FM_CONFIGURATION_OPTION_VALUES.PUBLIC_HOLIDAYS_VIEW_ENABLED;
    setIsPublicHolidaysEnabled(isEnabled);
    setOriginalValue(isEnabled);
  }, [currentUserViewSetting]);

  const resetToOriginalValue = () => {
    setIsPublicHolidaysEnabled(originalValue);
  };

  const onCloseModal = () => {
    resetToOriginalValue();
    onClose();
  };

  const handleCheckboxChange = () => {
    setIsPublicHolidaysEnabled(!isPublicHolidaysEnabled);
  };

  const saveSettings = () => {
    const viewSettingsId =
      fmConfigurationOptions?.find(
        (option) => option.setting_key === FM_CONFIGURATION_OPTION_KEY
      )?.view_settings_id ?? '';

    const newValueId =
      fmConfigurationOptions?.find((option) => {
        const isEnabledValue =
          option.value ===
          FM_CONFIGURATION_OPTION_VALUES.PUBLIC_HOLIDAYS_VIEW_ENABLED;
        return isEnabledValue === isPublicHolidaysEnabled;
      })?.view_settings_values_id ?? '';

    dispatch(
      createUpdateUserViewSetting({
        view_settings_id: viewSettingsId,
        view_settings_values_id: newValueId,
      })
    );

    onClose();
  };
  return (
    <Modal
      title={intl.get('SCHEDULE.SETTINGS_MODAL.TITLE')}
      titleIcon={{ src: ConfigureEventViewIcon }}
      isOpen={showModal}
      closeModal={onCloseModal}
      size='medium'
      aria-label={intl.get('SCHEDULE.SETTINGS_MODAL.TITLE')}
      data-testid='learning-schedule-settings-modal'
    >
      <div className='flex mt-6 space-x-2 mb-8'>
        <Checkbox
          value=''
          label={intl.get('SCHEDULE.SETTINGS_MODAL.SHOW_REGIONAL_HOLIDAYS')}
          className='ml-4'
          inputProps={{ className: 'mr-3' }}
          onChange={handleCheckboxChange}
          checked={isPublicHolidaysEnabled}
        />
        {/* <Typography variant='label' className='text-lg py-2'>
          {intl.get('SCHEDULE.SETTINGS_MODAL.SHOW_REGIONAL_HOLIDAYS')}
        </Typography> */}
      </div>
      <div className='flex mt-6 space-x-2'>
        <Button
          key={'fm-settings-save-changes-button'}
          variant='primary'
          onClick={saveSettings}
          data-cy='fm-settings-save-changes-button'
          className='h-10'
        >
          {intl.get('SCHEDULE.SETTINGS_MODAL.SAVE_CHANGES')}
        </Button>
        <Button
          key={'fm-settings-cancel-button'}
          variant='tertiary'
          className='h-10'
          onClick={onCloseModal}
          data-cy='fm-settings-cancel-button'
        >
          {intl.get('SCHEDULE.SETTINGS_MODAL.CANCEL')}
        </Button>
      </div>
    </Modal>
  );
};

export default SettingsModal;
